import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';

export default function MapLegend({ viewMode }) {
  const map = useMap();
  useEffect(() => {
    const legend = L.control({ position: 'bottomright' });
    legend.onAdd = () => {
      const div = L.DomUtil.create('div', 'info legend');
      div.style.backgroundColor = 'white';
      div.style.padding = '10px';
      div.style.borderRadius = '5px';
      div.style.boxShadow = '0 0 15px rgba(0,0,0,0.2)';

      const labels = viewMode === 'resident' ? {
        title: "Amenity Access",
        low: "Low Access",
        mid: "Moderate",
        high: "High Access"
      } : {
        title: "Opportunity Gap",
        low: "Critical Service Gap",
        mid: "Moderate Need",
        high: "Saturated / Well Served"
      };

      div.innerHTML = `
        <h4 style="margin:0 0 5px 0;">${labels.title}</h4>
        <div style="display: flex; align-items: center; margin-bottom: 2px;">
          <div style="width: 20px; height: 20px; background: #fde725; margin-right: 8px; opacity: 0.7;"></div> ${labels.low}
        </div>
        <div style="display: flex; align-items: center; margin-bottom: 2px;">
          <div style="width: 20px; height: 20px; background: #22a884; margin-right: 8px; opacity: 0.7;"></div> ${labels.mid}
        </div>
        <div style="display: flex; align-items: center; margin-bottom: 2px;">
          <div style="width: 20px; height: 20px; background: #440154; margin-right: 8px; opacity: 0.7;"></div> ${labels.high}
        </div>
      `;
      return div;
    };
    legend.addTo(map);
    return () => legend.remove();
  }, [map, viewMode]);
  return null;
}
